{
	"ContactUsPage": {
		"index": 0
	},
	"Features 01": {
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "---"
			},
			"type": "TextArea",
			"value": "---\nmarkedContent"
		},
		"index": 1,
		"theme": {
			"permission": "Admin",
			"translations": {
				"en-US": "light"
			},
			"type": "TextInput",
			"value": "light"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "test"
			},
			"type": "TextInput",
			"value": "test"
		}
	},
	"Features Contact Us": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "Form Contact Us"
				},
				"containerClass": {
					"translations": {},
					"value": "xl:col-span-2"
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "Features For Page Location Services"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "w-full mx-2 sm:mx-4 my-4 sm:my-8 lg:my-16"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "xl:grid xl:grid-cols-3 xl:gap-4"
				}
			}
		},
		"index": 2,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"Features For Page Location Services": {
		"Feature 01 Address": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "العنوان المنسق",
						"en": "formattedAddress",
						"en-GB": "formattedAddress",
						"en-US": "formattedAddress",
						"es": "dirección formateada",
						"es-419": "dirección formateada",
						"es-ES": "dirección formateada",
						"he": "כתובת מעוצבת",
						"it": "Indirizzo formattato",
						"pl": "sformatowanyAdres",
						"sw": "Anwani iliyopangwa",
						"tl": "naka-format na Address",
						"vi": "Địa chỉ được định dạng",
						"zh": "格式化地址"
					},
					"value": "formattedAddress"
				},
				"title": {
					"translations": {
						"ar": "عنوان",
						"en": "Address",
						"en-GB": "Address",
						"en-US": "Address",
						"es": "DIRECCIÓN",
						"es-419": "DIRECCIÓN",
						"es-ES": "DIRECCIÓN",
						"he": "כְּתוֹבֶת",
						"it": "Indirizzo",
						"pl": "Adres",
						"sw": "Anwani",
						"tl": "Tirahan",
						"vi": "Địa chỉ",
						"zh": "地址"
					},
					"value": "Address"
				}
			}
		},
		"Feature 01 Address Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"address-card\",\"icon\":[576,512,[62140,\"contact-card\",\"vcard\"],\"f2bb\",\"M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-24-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm240-48l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z\"]}",
				"name": "faAddressCard"
			}
		},
		"Feature 02 Phone": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "Location.value.response-nationalPhoneNumber",
						"en": "Location.value.response-nationalPhoneNumber",
						"en-GB": "Location.value.response-nationalPhoneNumber",
						"en-US": "Location.value.response-nationalPhoneNumber",
						"es": "Ubicación.valor.respuesta-númeroteléfononacional",
						"es-419": "Ubicación.valor.respuesta-númeroteléfononacional",
						"es-ES": "Ubicación.valor.respuesta-númeroteléfononacional",
						"he": "מספר טלפון לאומי (Location.value.response-national)",
						"it": "Posizione.valore.risposta-numero di telefono nazionale",
						"pl": "Lokalizacja.wartość.odpowiedź-krajowyNumerTelefonu",
						"sw": "Nambari ya Simu ya Eneo.thamani.jibu-national",
						"tl": "Lokasyon.halaga.tugon-pambansaNumero ng Telepono",
						"vi": "Vị trí.giá trị.phản hồi-số điện thoại quốc gia",
						"zh": "Location.value.response-nationalPhoneNumber"
					},
					"value": "Location.value.response-nationalPhoneNumber"
				},
				"title": {
					"translations": {
						"ar": "الهاتف",
						"en": "Telephone",
						"en-GB": "Telephone",
						"en-US": "Telephone",
						"es": "Teléfono",
						"es-419": "Teléfono",
						"es-ES": "Teléfono",
						"he": "טֵלֵפוֹן",
						"it": "Telefono",
						"pl": "Telefon",
						"sw": "Simu",
						"tl": "Telepono",
						"vi": "Điện thoại",
						"zh": "电话"
					},
					"value": "Telephone"
				}
			}
		},
		"Feature 02 Phone Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"phone\",\"icon\":[512,512,[128222,128379],\"f095\",\"M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z\"]}",
				"name": "faPhone"
			}
		},
		"Feature 03 Hours": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "ساعات مبسطة",
						"en": "hoursSimplified",
						"en-GB": "hoursSimplified",
						"en-US": "hoursSimplified",
						"es": "horasSimplificado",
						"es-419": "horasSimplificado",
						"es-ES": "horasSimplificado",
						"he": "שעותפשוט",
						"it": "oreSemplificate",
						"pl": "godzinyUproszczone",
						"sw": "saaIliyorahisishwa",
						"tl": "orasPinasimple",
						"vi": "giờ đơn giản",
						"zh": "小时简化"
					},
					"value": "hoursSimplified"
				},
				"title": {
					"translations": {
						"ar": "ساعات",
						"en": "Hours",
						"en-GB": "Hours",
						"en-US": "Hours",
						"es": "Horas",
						"es-419": "Horas",
						"es-ES": "Horas",
						"he": "שעות",
						"it": "Ore",
						"pl": "Godziny",
						"sw": "Saa za kazi",
						"tl": "Mga Oras",
						"vi": "Giờ",
						"zh": "小时"
					},
					"value": "Hours"
				}
			}
		},
		"Feature 03 Hours Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"clock\",\"icon\":[512,512,[128339,\"clock-four\"],\"f017\",\"M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z\"]}",
				"name": "faClock"
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureClass": {
					"translations": {},
					"value": "grid grid-cols-[auto_1fr] gap-x-2 sm:gap-x-4"
				},
				"featureContentClass": {
					"translations": {},
					"value": "col-start-2"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 sm:gap-4"
				}
			}
		},
		"docId": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "location"
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "locations"
		},
		"hoursSimplified": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput"
		},
		"iconSize": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "2x"
		},
		"index": 3
	},
	"Form Contact Us": {
		"Question 00": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### Contact Us\n---\nFill out the form below and someone will reach out to you."
				},
				"headingClass": {
					"translations": {},
					"value": "w-full"
				},
				"label": {
					"translations": {},
					"value": ""
				}
			}
		},
		"Question 01": {
			"permission": "Admin",
			"textObject": "label: Name\nheading: Full Name\ncolSpan: col-span-2\ntype: text\nrequired: true\ninvalidMessage: Please enter your Name",
			"translations": {},
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Full Name"
				},
				"hideLabel": {
					"translations": {},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your Name"
				},
				"label": {
					"translations": {},
					"value": "Name"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 02": {
			"permission": "Admin",
			"textObject": "heading: Email Address\nlabel: Email Address\ncolSpan: col-span-1\ntype: email\nrequired: true\ninvalidMessage: Please enter a valid email address",
			"translations": {},
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Email Address"
				},
				"hideLabel": {
					"translations": {},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter a valid email address"
				},
				"label": {
					"translations": {},
					"value": "Email Address"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "email"
				}
			}
		},
		"Question 03": {
			"permission": "Admin",
			"textObject": "label: Phone Number\nheading: Phone Number\ncolSpan: col-span-1\ntype: tel\nrequired: true\ninvalidMessage: Please Enter a valid phone number",
			"translations": {},
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Phone Number"
				},
				"hideLabel": {
					"translations": {},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please Enter a valid phone number"
				},
				"label": {
					"translations": {},
					"value": "Phone Number"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "tel"
				}
			}
		},
		"Question 04": {
			"permission": "Admin",
			"textObject": "label: Message\nheading: Your message (optional)\ncolSpan: col-span-2\ntype: textarea",
			"translations": {},
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Your message (optional)"
				},
				"hideLabel": {
					"translations": {},
					"value": "true"
				},
				"label": {
					"translations": {},
					"value": "Message"
				},
				"type": {
					"translations": {},
					"value": "textarea"
				}
			}
		},
		"Question 05": {
			"permission": "Admin",
			"textObject": "heading: I agree to accept text messages from the Law Office of Thomas Johnson Moore\nlabel: Consent\ncolSpan: col-span-2\noptions: [\"I agree\"]\ntype: checkbox\noptionLabelPos: right\nrequired: true\ninvalidMessage: You must consent to agree to receive text messages",
			"translations": {},
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "I agree to accept text messages from the Law Office of Thomas Johnson Moore"
				},
				"hideLabel": {
					"translations": {},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {},
					"value": "You must consent to agree to receive text messages"
				},
				"label": {
					"translations": {},
					"value": "Consent"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"options": {
					"translations": {},
					"value": "I agree"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"requiredCount": {
					"translations": {},
					"value": "1"
				},
				"type": {
					"translations": {},
					"value": "checkbox"
				}
			}
		},
		"Section 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {},
					"value": "Contact Information"
				},
				"questions": {
					"translations": {},
					"value": "Question 00+||+Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"general": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"confirmationMessage": {
					"translations": {},
					"value": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*"
				},
				"formName": {
					"translations": {},
					"value": "Contact Us"
				}
			}
		},
		"heading": {
			"permission": "Admin",
			"translations": {
				"en-US": "### Contact Us\n---\nFill out the form below and someone will reach out to you."
			},
			"type": "TextArea",
			"value": "### Contact Us\n---\nFill out the form below and someone will reach out to you."
		},
		"index": 4,
		"section": {
			"permission": "Admin",
			"textObject": "label: Contact Information\nsection: Contact Information",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"en": "Contact Information",
						"en-US": "Contact Information"
					},
					"value": "Contact Information"
				},
				"section": {
					"translations": {
						"en": "Contact Information",
						"en-US": "Contact Information"
					},
					"value": "Contact Information"
				}
			}
		}
	},
	"FormSubmission 01": {
		"Question 01": {
			"permission": "Admin",
			"textObject": "label: Name\nheading: Full Name\ncolSpan: col-span-2\ntype: text\nrequired: true\ninvalidMessage: Please enter your Name",
			"translations": {},
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "col-span-2",
						"en-US": "col-span-2"
					},
					"value": "col-span-2"
				},
				"heading": {
					"translations": {
						"en": "Full Name",
						"en-US": "Full Name"
					},
					"value": "Full Name"
				},
				"invalidMessage": {
					"translations": {
						"en-US": ""
					},
					"value": "Please enter your Name"
				},
				"label": {
					"translations": {
						"en": "Name",
						"en-US": "Name"
					},
					"value": "Name"
				},
				"required": {
					"translations": {
						"en": "true",
						"en-US": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "text",
						"en-US": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 02": {
			"permission": "Admin",
			"textObject": "heading: Email Address\nlabel: Email Address\ncolSpan: col-span-1\ntype: email\nrequired: true\ninvalidMessage: Please enter a valid email address",
			"translations": {},
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "col-span-2",
						"en-US": "col-span-2"
					},
					"value": "col-span-1"
				},
				"heading": {
					"translations": {
						"en": "I agree to accept text messages from Advanced Collision Experts",
						"en-US": "I agree to accept text messages from Advanced Collision Experts"
					},
					"value": "Email Address"
				},
				"invalidMessage": {
					"translations": {
						"en": "You must consent to agree to receive text messages",
						"en-US": "You must consent to agree to receive text messages"
					},
					"value": "Please enter a valid email address"
				},
				"label": {
					"translations": {
						"en": "Consent x",
						"en-US": "Consent x"
					},
					"value": "Email Address"
				},
				"required": {
					"translations": {
						"en": "true",
						"en-US": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "checkbox",
						"en-US": "checkbox"
					},
					"value": "email"
				}
			}
		},
		"Question 03": {
			"permission": "Admin",
			"textObject": "label: Phone Number\nheading: Phone Number\ncolSpan: col-span-1\ntype: tel\nrequired: true\ninvalidMessage: Please Enter a valid phone number",
			"translations": {},
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "col-span-1",
						"en-US": "col-span-1"
					},
					"value": "col-span-1"
				},
				"heading": {
					"translations": {
						"en": "Phone Number",
						"en-US": "Phone Number"
					},
					"value": "Phone Number"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please Enter a valid phone number",
						"en-US": "Please Enter a valid phone number"
					},
					"value": "Please Enter a valid phone number"
				},
				"label": {
					"translations": {
						"en": "Phone Number",
						"en-US": "Phone Number"
					},
					"value": "Phone Number"
				},
				"required": {
					"translations": {
						"en-US": ""
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "tel",
						"en-US": "tel"
					},
					"value": "tel"
				}
			}
		},
		"Question 04": {
			"permission": "Admin",
			"textObject": "label: Message\nheading: Your message (optional)\ncolSpan: col-span-2\ntype: textarea",
			"translations": {},
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "col-span-2",
						"en-US": "col-span-2"
					},
					"value": "col-span-2"
				},
				"heading": {
					"translations": {
						"en": "Your message (optional)",
						"en-US": "Your message (optional)"
					},
					"value": "Your message (optional)"
				},
				"label": {
					"translations": {
						"en": "Message",
						"en-US": "Message"
					},
					"value": "Message"
				},
				"type": {
					"translations": {
						"en": "textarea",
						"en-US": "textarea"
					},
					"value": "textarea"
				}
			}
		},
		"Question 05": {
			"permission": "Admin",
			"textObject": "heading: I agree to accept text messages from the Law Office of Thomas Johnson Moore\nlabel: Consent\ncolSpan: col-span-2\noptions: [\"I agree\"]\ntype: checkbox\noptionLabelPos: right\nrequired: true\ninvalidMessage: You must consent to agree to receive text messages",
			"translations": {},
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "col-span-2",
						"en-US": "col-span-2"
					},
					"value": "col-span-2"
				},
				"heading": {
					"translations": {
						"en": "I agree to accept text messages from the Law Office of Thomas Johnson Moore",
						"en-US": "I agree to accept text messages from the Law Office of Thomas Johnson Moore"
					},
					"value": "I agree to accept text messages from the Law Office of Thomas Johnson Moore"
				},
				"invalidMessage": {
					"translations": {
						"en": "You must consent to agree to receive text messages",
						"en-US": "You must consent to agree to receive text messages"
					},
					"value": "You must consent to agree to receive text messages"
				},
				"label": {
					"translations": {
						"en": "Consent",
						"en-US": "Consent"
					},
					"value": "Consent"
				},
				"optionLabelPos": {
					"translations": {
						"en": "right",
						"en-US": "right"
					},
					"value": "right"
				},
				"options": {
					"translations": {
						"en": "[\"I agree\"]",
						"en-US": "[\"I agree\"]"
					},
					"value": "[\"I agree\"]"
				},
				"required": {
					"translations": {
						"en": "true",
						"en-US": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "checkbox",
						"en-US": "checkbox"
					},
					"value": "checkbox"
				}
			}
		},
		"heading": {
			"permission": "Admin",
			"translations": {
				"en-US": "### Contact Us\n---\nFill out the form below and someone will reach out to you."
			},
			"type": "TextArea",
			"value": "### Contact Us\n---\nFill out the form below and someone will reach out to you."
		},
		"index": 5,
		"section": {
			"permission": "Admin",
			"textObject": "label: Contact Information\nsection: Contact Information",
			"translations": {},
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"en": "Contact Information",
						"en-US": "Contact Information"
					},
					"value": "Contact Information"
				},
				"section": {
					"translations": {
						"en": "Contact Information",
						"en-US": "Contact Information"
					},
					"value": "Contact Information"
				}
			}
		}
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fcontact%20us%2FPageBanner%2FbgImage%2FContact%20Us%20Banner.jpg?alt=media&token=ff65a9f9-cfdf-4e6d-93e7-c43bda0f1ba3",
				"formattedSize": "71.30 KB",
				"height": 488,
				"name": "Contact Us Banner.jpg",
				"path": "uploads/contact us/PageBanner/bgImage/Contact Us Banner.jpg",
				"query": "?as=run",
				"size": 73013,
				"type": "image/jpeg",
				"updated": "2025-02-22T00:53:15.230Z",
				"width": 1588
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "w-full"
				},
				"contentClass": {
					"translations": {},
					"value": "bg-base-300 inline-block p-2 sm:p-4 md:p-6 xl:p-8 rounded mx-2 sm:mx-4"
				}
			}
		},
		"index": 6,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Criminal Lawyers Birmingham Office of Thomas Johnson Moore"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Contact Us"
			},
			"type": "TextInput",
			"value": "Contact Us"
		}
	},
	"SideBySide": {
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "---\n"
			},
			"type": "TextArea",
			"value": "### Contact Us\n---\n"
		},
		"index": 7,
		"title": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": ""
		}
	}
}